import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[--color-brand-green-dark] text-[#BCC8B3] pt-16 pb-8 border-t border-[--color-brand-green-dark]/30">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
        {/* Company Info */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/9d491525-9d2e-415f-8dca-b2b6aa0afab4/logo.svg"
              alt="BP Totalservice Logo"
              className="h-10 w-auto"
            />
          </div>
          <p className="font-sans text-sm text-[#BCC8B3] leading-relaxed">
            Professionel haveservice og totalservice i Gelsted, Assens, Middelfart, Aarup og omegn. Vi leverer skræddersyede kvalitetsløsninger til dine behov.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="font-display text-base font-bold text-[#BCC8B3] mb-6 tracking-wide">
            Hurtige Links
          </h4>
          <ul className="space-y-3 font-sans text-sm text-[#BCC8B3]">
            <li>
              <Link to="/" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Forside
              </Link>
            </li>
            <li>
              <Link to="/ydelser" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Ydelser
              </Link>
            </li>
            <li>
              <Link to="/galleri" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Galleri
              </Link>
            </li>
            <li>
              <Link to="/om-os" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Om os
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Kontakt
              </Link>
            </li>
          </ul>
        </div>

        {/* Services Links */}
        <div>
          <h4 className="font-display text-base font-bold text-[#BCC8B3] mb-6 tracking-wide">
            Vores Ydelser
          </h4>
          <ul className="space-y-3 font-sans text-sm text-[#BCC8B3]">
            <li>
              <Link to="/ydelser/graesslaaning" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Græsslåning
              </Link>
            </li>
            <li>
              <Link to="/ydelser/ny-terrasse" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Ny terrasse
              </Link>
            </li>
            <li>
              <Link to="/ydelser/ny-indkoersel" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Ny indkørsel
              </Link>
            </li>
            <li>
              <Link to="/ydelser/etablering-af-graesplaener" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Etablering af græsplæner
              </Link>
            </li>
            <li>
              <Link to="/ydelser/brolaegning" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors">
                Brolægning
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h4 className="font-display text-base font-bold text-[#BCC8B3] mb-6 tracking-wide">
            Kontaktoplysninger
          </h4>
          <ul className="space-y-4 font-sans text-sm text-[#BCC8B3]">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-location-dot text-[#BCC8B3] mt-1"></i>
              <span>
                Søndergade 111,<br />
                5591 Gelsted
              </span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-[#BCC8B3]"></i>
              <a href="tel:30441611" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors whitespace-nowrap">
                30 44 16 11
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-envelope text-[#BCC8B3]"></i>
              <a href="mailto:post@bp-haveservice.dk" className="text-[#BCC8B3] hover:text-[#BCC8B3] transition-colors whitespace-nowrap">
                post@bp-haveservice.dk
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-id-card text-[#BCC8B3]"></i>
              <span>CVR: 32127347</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="max-w-7xl mx-auto px-6 pt-8 border-t border-[#BCC8B3]/20 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs font-sans text-[#BCC8B3]">
        <p>© {currentYear} BP Totalservice v/Børge Hovmann Poulsen. Alle rettigheder forbeholdes.</p>
        <p className="flex items-center gap-1">
          Udviklet med <i className="fa-solid fa-heart text-[#BCC8B3] text-[10px]"></i> i Danmark
        </p>
      </div>
    </footer>
  );
}
